import React from 'react';
import { map } from 'lodash';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import TextAreaField from 'shared-components/reduxForms/fields/TextAreaField/TextAreaField';
import cleaningPolicy from 'shared-components/cleaning-policy/data/cleaningTypes';
import CleaningTypeFields from './CleaningTypeFields';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

const CleaningFields = ({
  initialValues,
  intl
}) => {
  return (
    <div className="margin-xl-top">
      {
        map(cleaningPolicy, (policy, key) => (
          <Field
            name={key}
            initialValues={initialValues}
            nameKey={key}
            component={CleaningTypeFields}
            fields={policy}
            errorMessage={intl.formatMessage({ id: 'hosting.cleaning_fields.select_option_message', defaultMessage: 'Please select an option' })}
          />
        ))
      }
      <h6><FormattedMessage id="hosting.cleaning_fields.cleaning_process_heading" defaultMessage="Tell your guests more about your cleaning process"/></h6>
      <Field
        name="description"
        attributes={{
          'data-testing-id': 'cleaning-description'
        }}
        component={TextAreaField}
      />
      <div className="flex end">
        <p className="text-gray-600 margin-md-top"><FormattedMessage id="hosting.cleaning_fields.cleaning_process_minimum_characters_message" defaultMessage="Minimum 50 characters"/></p>
      </div>
    </div>
  );
};

CleaningFields.propTypes = {
  initialValues: PropTypes.object,
  intl: intlShape
};

export default injectIntl(CleaningFields);
